import React from 'react';
import classes from './CallPreview.module.scss';
import Tooltip from '../Tooltip/Tooltip';
import { FormattedMessage } from 'react-intl';
import _compact from 'lodash/compact';
import SVG from 'react-inlinesvg';
import micIcon from '@lifesize/ux-assets/vectors/svgIcons/mic.svg';
import micOffIcon from '@lifesize/ux-assets/vectors/svgIcons/mic-off.svg';

export interface Props {
  isAudioMuted: boolean;
  onAudioMuteClick: () => void;
}

const AudioButton = ({ isAudioMuted, onAudioMuteClick }: Props) => {
  const audioClassNames = _compact([
    classes.preCallButton,
    !isAudioMuted ? '' : classes.muted
  ]).join(' ');

  return (
    <button
      className={audioClassNames}
      onClick={onAudioMuteClick}
    >
      {!isAudioMuted ? <SVG src={micIcon} data-testid="micIcon" /> : <SVG src={micOffIcon} data-testid="micOffIcon" />}
      <Tooltip
        location="top"
        style={{ bottom: '100%', marginBottom: 15 }} label={
        !isAudioMuted ?
          <FormattedMessage
            id="components.callPreview.controls.audioMute.tooltip.off"
            defaultMessage="Mute microphone"
          /> :
          <FormattedMessage
            id="components.callPreview.controls.audioMute.tooltip.on"
            defaultMessage="Unmute Microphone"
          />
      }
      />
    </button>
  );
};

export default AudioButton;
